import React from 'react'
import { TransactionHistoryState } from '../../../utils/dbModels/HistoryTransaction'
import { GimGimmer } from '../../../utils/requestsUtils/functionsRequests/offers/offersFunctions'
import { useTranslation } from 'react-i18next'

type StateTransactionHistoryLabelProps = {
    state: TransactionHistoryState
    type: GimGimmer
    height?: string | number
    sizeLetter?: string | number
}

const StateTransactionHistoryLabel = ({ state, type, height = "2.8rem", sizeLetter="fs-13" }: StateTransactionHistoryLabelProps) => {
  
    const { t } = useTranslation()

    let classes = "border-radius-3 center pl-14 pr-14 mt-1"
    let text = ""
    if(state === "FINISH"){
        if(type === "Gim"){
            classes += " gim-bg"
        }
        else{
            classes += " gimmer-bg"
        }
        text = t("History:label_13")
    }else{
        classes += " alert-bg"
        text = t("History:label_14")
    }
        

    return (
        <div className={classes} style={{ height }}>
            <p className={`c-white fw-500 ${sizeLetter}`}>{text}</p>
        </div>
    )
}

export default React.memo( StateTransactionHistoryLabel )